export const SET_CONTRIBUTOR = "SET_CONTRIBUTOR";
export const DELETE_CONTRIBUTOR = "DELETE_CONTRIBUTOR";
